import React, { useState, useEffect } from "react";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
	Button,
	TextField,
	MuiThemeProvider,
	createMuiTheme,
	FormControlLabel,
	Checkbox,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
	deleteClub,
	getClubById,
	postClub,
	updateClub,
} from "../../../../api/club";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertInfo, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import PreviewDialog from '../../../components/dialogs/PreviewDialog';
import { SERVER_URL } from '../../../../utils';

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyClub() {
	return {
		fullName: "",
		active: true,
		logo: "",
	};
}

export default function EditClubsPage() {
	const [club, setClub] = useState(getEmptyClub());
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [selectedLogo, setSelectedLogo] = useState(null);
	const [previewLogoOpen, setPreviewLogoOpen] = useState(false);
	const clubId = useParams().id;
	const history = useHistory();

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!clubId) {
			disableLoadingData();
			return;
		}
		getClubById(clubId)
			.then((res) => {
				if (res.status === 200) {
					setClub(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get club.",
				});
				history.push("/clubs");
			});
	}, [clubId, disableLoadingData, history]);

	function saveClub() {
		if (!clubId) {
			postClub(club, selectedLogo)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Club successfully created."
						});
						history.push("/clubs");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save club.",
					});
				});
		} else {
			updateClub(clubId, club, selectedLogo)
				.then((res) => {
					if (res.status === 200) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Changes successfully saved.",
						});
						history.push("/clubs");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save changes.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setClub({ ...club, [element]: event.target.value });
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title="Edit club"></CardHeader>
					<CardBody>
						<TextField
							id={`fullName`}
							label="Full name"
							value={club.fullName}
							onChange={handleChange("fullName")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						<label className="mt-4" htmlFor="upload-logo">
							<input
								style={{ display: "none" }}
								id="upload-logo"
								name="upload-logo"
								type="file"
								accept="image/*"
								onChange={(e) => {
									setSelectedLogo(e.target.files[0]);
								}}
							/>
							<Button
								style={{ marginRight: "15px" }}
								color="secondary"
								component="span"
								variant="outlined"
							>
								{selectedLogo || club.logo
									? "Change logo file"
									: "Upload logo file"}
							</Button>
						</label>

						{(selectedLogo || club.logo) && (
							<>
								<Button
									onClick={() => setPreviewLogoOpen(true)}
									style={{ marginRight: "15px" }}
									variant="outlined"
								>
									{"Preview logo"}
								</Button>
								<PreviewDialog
									title="Logo"
									open={previewLogoOpen}
									setOpen={setPreviewLogoOpen}
									src={
										selectedLogo
											? URL.createObjectURL(selectedLogo)
											: `${SERVER_URL}/${club.logo}`
									}
								/>
							</>
						)}
						<br />
						<br />
						<FormControlLabel
							control={
								<Checkbox
									checked={club.active}
									onChange={() =>
										setClub({
											...club,
											active: !club.active,
										})
									}
									name="checkActive"
								/>
							}
							label="Active"
						/>
					</CardBody>
				</Card>
				<Button
					onClick={() => history.push("/clubs")}
					variant="outlined"
					style={{ marginRight: "20px" }}
				>
					Back
				</Button>
				<Button
					onClick={() => saveClub()}
					variant="outlined"
					color="primary"
					style={{ marginRight: "20px" }}
				>
					Save club
				</Button>
				{clubId && (
					<>
						<MuiThemeProvider theme={theme}>
							<Button
								onClick={() => setOpenConfirmDialog(true)}
								variant="outlined"
								color="secondary"
							>
								Delete club
							</Button>
						</MuiThemeProvider>

						<ConfirmDialog
							title={"Are you sure you want to delete this club?"}
							open={openConfirmDialog}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								deleteClub(clubId)
									.then((res) => {
										if (res.status === 204) {
											alertSuccess({
												title: "Deleted!",
												customMessage:
													"Club deleted successfully",
											});
											history.push("/clubs");
										}
									})
									.catch((error) => {
										alertError({
											error: error,
											customMessage:
												"Could not delete economic sector.",
										});
									});
							}}
						/>
					</>
				)}
			</>
		);
}
